/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsRpc
 */
import * as References from './ApprovalsRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
export const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsRpc#createApproval
 */
export const CREATE_APPROVAL_MUTATION_FIELD_NAME = 'com_hubspot_product_approvals_rpc_ApprovalsRpc_createApproval';
export const CREATE_APPROVAL_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CREATE_APPROVAL_MUTATION_FIELD_NAME,
  args: ['approvalTypeId', 'approvalAction', 'approvableObjectId', 'approvalSteps', 'approvalRules', 'title', 'requestNote', 'dueDate'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.createApprovalRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsRpc#createBulkApproval
 */
export const CREATE_BULK_APPROVAL_MUTATION_FIELD_NAME = 'com_hubspot_product_approvals_rpc_ApprovalsRpc_createBulkApproval';
export const CREATE_BULK_APPROVAL_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CREATE_BULK_APPROVAL_MUTATION_FIELD_NAME,
  args: ['approvalRequests'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.createBulkApprovalRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsRpc#getLatestApproval
 */
export const GET_LATEST_APPROVAL_QUERY_FIELD_NAME = 'com_hubspot_product_approvals_rpc_ApprovalsRpc_getLatestApproval';
export const GET_LATEST_APPROVAL_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_LATEST_APPROVAL_QUERY_FIELD_NAME,
  args: ['approvalTypeId', 'approvalAction', 'approvableObjectId'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.getLatestApprovalRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsRpc#getApproval
 */
export const GET_APPROVAL_QUERY_FIELD_NAME = 'com_hubspot_product_approvals_rpc_ApprovalsRpc_getApproval';
export const GET_APPROVAL_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_APPROVAL_QUERY_FIELD_NAME,
  args: ['approvalId'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.getApprovalRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsRpc#approveApproval
 */
export const APPROVE_APPROVAL_MUTATION_FIELD_NAME = 'com_hubspot_product_approvals_rpc_ApprovalsRpc_approveApproval';
export const APPROVE_APPROVAL_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: APPROVE_APPROVAL_MUTATION_FIELD_NAME,
  args: ['approvalId', 'note'],
  fetcher(request, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.approveApprovalRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsRpc#approveApprovalStep
 */
export const APPROVE_APPROVAL_STEP_MUTATION_FIELD_NAME = 'com_hubspot_product_approvals_rpc_ApprovalsRpc_approveApprovalStep';
export const APPROVE_APPROVAL_STEP_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: APPROVE_APPROVAL_STEP_MUTATION_FIELD_NAME,
  args: ['approvalStepId', 'note'],
  fetcher(request, ctx) {
    var _ctx$customClient6;
    return ((_ctx$customClient6 = ctx.customClient) !== null && _ctx$customClient6 !== void 0 ? _ctx$customClient6 : chirpClient).call(References.approveApprovalStepRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsRpc#rejectApproval
 */
export const REJECT_APPROVAL_MUTATION_FIELD_NAME = 'com_hubspot_product_approvals_rpc_ApprovalsRpc_rejectApproval';
export const REJECT_APPROVAL_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: REJECT_APPROVAL_MUTATION_FIELD_NAME,
  args: ['approvalId', 'rejectionNote'],
  fetcher(request, ctx) {
    var _ctx$customClient7;
    return ((_ctx$customClient7 = ctx.customClient) !== null && _ctx$customClient7 !== void 0 ? _ctx$customClient7 : chirpClient).call(References.rejectApprovalRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsRpc#rejectApprovalStep
 */
export const REJECT_APPROVAL_STEP_MUTATION_FIELD_NAME = 'com_hubspot_product_approvals_rpc_ApprovalsRpc_rejectApprovalStep';
export const REJECT_APPROVAL_STEP_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: REJECT_APPROVAL_STEP_MUTATION_FIELD_NAME,
  args: ['approvalStepId', 'rejectionNote'],
  fetcher(request, ctx) {
    var _ctx$customClient8;
    return ((_ctx$customClient8 = ctx.customClient) !== null && _ctx$customClient8 !== void 0 ? _ctx$customClient8 : chirpClient).call(References.rejectApprovalStepRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsRpc#requestChangesOnApproval
 */
export const REQUEST_CHANGES_ON_APPROVAL_MUTATION_FIELD_NAME = 'com_hubspot_product_approvals_rpc_ApprovalsRpc_requestChangesOnApproval';
export const REQUEST_CHANGES_ON_APPROVAL_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: REQUEST_CHANGES_ON_APPROVAL_MUTATION_FIELD_NAME,
  args: ['approvalId', 'note'],
  fetcher(request, ctx) {
    var _ctx$customClient9;
    return ((_ctx$customClient9 = ctx.customClient) !== null && _ctx$customClient9 !== void 0 ? _ctx$customClient9 : chirpClient).call(References.requestChangesOnApprovalRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsRpc#requestChangesOnApprovalStep
 */
export const REQUEST_CHANGES_ON_APPROVAL_STEP_MUTATION_FIELD_NAME = 'com_hubspot_product_approvals_rpc_ApprovalsRpc_requestChangesOnApprovalStep';
export const REQUEST_CHANGES_ON_APPROVAL_STEP_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: REQUEST_CHANGES_ON_APPROVAL_STEP_MUTATION_FIELD_NAME,
  args: ['approvalStepId', 'note'],
  fetcher(request, ctx) {
    var _ctx$customClient10;
    return ((_ctx$customClient10 = ctx.customClient) !== null && _ctx$customClient10 !== void 0 ? _ctx$customClient10 : chirpClient).call(References.requestChangesOnApprovalStepRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsRpc#markChangesResolved
 */
export const MARK_CHANGES_RESOLVED_MUTATION_FIELD_NAME = 'com_hubspot_product_approvals_rpc_ApprovalsRpc_markChangesResolved';
export const MARK_CHANGES_RESOLVED_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: MARK_CHANGES_RESOLVED_MUTATION_FIELD_NAME,
  args: ['approvalStepId', 'message'],
  fetcher(request, ctx) {
    var _ctx$customClient11;
    return ((_ctx$customClient11 = ctx.customClient) !== null && _ctx$customClient11 !== void 0 ? _ctx$customClient11 : chirpClient).call(References.markChangesResolvedRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsRpc#requestAgentToApplyChanges
 */
export const REQUEST_AGENT_TO_APPLY_CHANGES_MUTATION_FIELD_NAME = 'com_hubspot_product_approvals_rpc_ApprovalsRpc_requestAgentToApplyChanges';
export const REQUEST_AGENT_TO_APPLY_CHANGES_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: REQUEST_AGENT_TO_APPLY_CHANGES_MUTATION_FIELD_NAME,
  args: ['approvalStepId', 'message'],
  fetcher(request, ctx) {
    var _ctx$customClient12;
    return ((_ctx$customClient12 = ctx.customClient) !== null && _ctx$customClient12 !== void 0 ? _ctx$customClient12 : chirpClient).call(References.requestAgentToApplyChangesRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsRpc#requestAgentToReview
 */
export const REQUEST_AGENT_TO_REVIEW_MUTATION_FIELD_NAME = 'com_hubspot_product_approvals_rpc_ApprovalsRpc_requestAgentToReview';
export const REQUEST_AGENT_TO_REVIEW_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: REQUEST_AGENT_TO_REVIEW_MUTATION_FIELD_NAME,
  args: ['approvalStepId', 'message'],
  fetcher(request, ctx) {
    var _ctx$customClient13;
    return ((_ctx$customClient13 = ctx.customClient) !== null && _ctx$customClient13 !== void 0 ? _ctx$customClient13 : chirpClient).call(References.requestAgentToReviewRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsRpc#cancelAgentTurn
 */
export const CANCEL_AGENT_TURN_MUTATION_FIELD_NAME = 'com_hubspot_product_approvals_rpc_ApprovalsRpc_cancelAgentTurn';
export const CANCEL_AGENT_TURN_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CANCEL_AGENT_TURN_MUTATION_FIELD_NAME,
  args: ['approvalStepId', 'message'],
  fetcher(request, ctx) {
    var _ctx$customClient14;
    return ((_ctx$customClient14 = ctx.customClient) !== null && _ctx$customClient14 !== void 0 ? _ctx$customClient14 : chirpClient).call(References.cancelAgentTurnRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsRpc#cancelApproval
 */
export const CANCEL_APPROVAL_MUTATION_FIELD_NAME = 'com_hubspot_product_approvals_rpc_ApprovalsRpc_cancelApproval';
export const CANCEL_APPROVAL_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CANCEL_APPROVAL_MUTATION_FIELD_NAME,
  args: ['approvalId', 'note'],
  fetcher(request, ctx) {
    var _ctx$customClient15;
    return ((_ctx$customClient15 = ctx.customClient) !== null && _ctx$customClient15 !== void 0 ? _ctx$customClient15 : chirpClient).call(References.cancelApprovalRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsRpc#concludeApproval
 */
export const CONCLUDE_APPROVAL_MUTATION_FIELD_NAME = 'com_hubspot_product_approvals_rpc_ApprovalsRpc_concludeApproval';
export const CONCLUDE_APPROVAL_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CONCLUDE_APPROVAL_MUTATION_FIELD_NAME,
  args: ['approvableObjectId', 'approvalTypeId', 'approvalAction', 'approvalConclusionReason'],
  fetcher(request, ctx) {
    var _ctx$customClient16;
    return ((_ctx$customClient16 = ctx.customClient) !== null && _ctx$customClient16 !== void 0 ? _ctx$customClient16 : chirpClient).call(References.concludeApprovalRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsRpc#updateApproval
 */
export const UPDATE_APPROVAL_MUTATION_FIELD_NAME = 'com_hubspot_product_approvals_rpc_ApprovalsRpc_updateApproval';
export const UPDATE_APPROVAL_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UPDATE_APPROVAL_MUTATION_FIELD_NAME,
  args: ['approvalId', 'approvalSteps', 'dueDate', 'title'],
  fetcher(request, ctx) {
    var _ctx$customClient17;
    return ((_ctx$customClient17 = ctx.customClient) !== null && _ctx$customClient17 !== void 0 ? _ctx$customClient17 : chirpClient).call(References.updateApprovalRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsRpc#sendReminderNotification
 */
export const SEND_REMINDER_NOTIFICATION_MUTATION_FIELD_NAME = 'com_hubspot_product_approvals_rpc_ApprovalsRpc_sendReminderNotification';
export const SEND_REMINDER_NOTIFICATION_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: SEND_REMINDER_NOTIFICATION_MUTATION_FIELD_NAME,
  args: ['approvalStepId'],
  fetcher(request, ctx) {
    var _ctx$customClient18;
    return ((_ctx$customClient18 = ctx.customClient) !== null && _ctx$customClient18 !== void 0 ? _ctx$customClient18 : chirpClient).call(References.sendReminderNotificationRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});